import React from "react";
import { t } from "i18next";
import { Link } from "react-router-dom";

const menuItems = [
  {
    label: <Link to="/setting">{t("text_general")}</Link>,
    key: "/setting",
  },
  {
    type: "divider",
  },
  {
    label: <Link to="/setting/department">{t("text_department")}</Link>,
    key: "/setting/department",
  },
  {
    label: <Link to="/setting/team">{t("text_team")}</Link>,
    key: "/setting/team",
  },
  {
    label: <Link to="/setting/role">{t("text_role")}</Link>,
    key: "/setting/role",
  },
  {
    label: <Link to="/setting/job-level">{t("text_job_level")}</Link>,
    key: "/setting/job-level",
  },
  {
    label: <Link to="/setting/job-grade">{t("text_job_grade")}</Link>,
    key: "/setting/job-grade",
  },
  {
    label: <Link to="/setting/duty-station">{t("text_duty_station_setting")}</Link>,
    key: "/setting/duty-station",
  },
  {
    type: "divider",
  },
  {
    label: <Link to="/setting/visa-type">{t("text_visa_type")}</Link>,
    key: "/setting/visa-type",
  },
  {
    label: <Link to="/setting/passport-type">{t("text_passport_type")}</Link>,
    key: "/setting/passport-type",
  },
  {
    label: <Link to="/setting/nationality">{t("text_nationality")}</Link>,
    key: "/setting/nationality",
  },
  {
    type: "divider",
  },
  // {
  //   label: <Link to="/setting/overtime-type">{t("text_over_time_type")}</Link>,
  //   key: "/setting/overtime-type",
  // },
  {
    label: <Link to="/setting/leave-type">{t("text_leave_types")}</Link>,
    key: "/setting/leave-type",
  },
  {
    label: <Link to="/setting/public-holiday">{t("text_holiday")}</Link>,
    key: "/setting/public-holiday",
  },
  {
    type: "divider",
  },
  {
    label: <Link to="/setting/payroll-item">{t("text_payroll_item")}</Link>,
    key: "/setting/payroll-item",
  },
  {
    label: <Link to="/setting/salary-tax-rate">{t("text_salary_tax_rate")}</Link>,
    key: "/setting/salary-tax-rate",
  },
  {
    label: <Link to="/setting/pension-fund">{t("text_pension_fund")}</Link>,
    key: "/setting/pension-fund",
  },
  {
    label: <Link to="/setting/nssf">{t("text_nssf")}</Link>,
    key: "/setting/nssf",
  },
  {
    label: <Link to="/setting/seniority-severance">Seniority & Severance Pay</Link>,
    key: "/setting/seniority-severance",
  },

];

export default menuItems;
